import { authIsBusy } from './AuthStore';

export const updateAuthIsBusy = (value) => authIsBusy.update((oldValue) => value);
